import Masonry from 'masonry-layout';
import { throttle } from 'throttle-debounce';
import { Lightbox } from '../../atoms/atomLightbox';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-gallery"]';

/**
 * Friendation component
 */
export const blockGallery = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const gallery = <HTMLUListElement>component.querySelector('.gallery-list');
    let masonry: Masonry;

    const handleMasonry = () => {
      let gutter: number = 32;

      const updateGutter = () => {
        /**
         * Detect table breakpoints
         */

        const isTablet: boolean = window.matchMedia(
          '(max-width: 1279px)'
        ).matches;
        if (isTablet) {
          gutter = 12;
        } else {
          gutter = 32;
        }
        masonry.options.gutter = gutter;
        masonry.layout();
      };

      if (!masonry) {
        masonry = new Masonry(gallery, {
          itemSelector: '.item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
          horizontalOrder: true,
          resize: false
        });
      }

      updateGutter();

      const onResize = throttle(100, updateGutter);
      window.addEventListener('resize', onResize);

      return masonry;
    };

    /**
     * We show the first 8 elements on load. Alle other elements are loaded on click. We load 8 items per click.
     */
    const handleLoadMore = () => {
      /** Load more button */
      const trigger: HTMLButtonElement = component.querySelector('.loadmore');
      if (!trigger) return;

      /** Items to load */
      const items: HTMLElement[] = Array.from(
        gallery.querySelectorAll('.item')
      );

      /** Index */
      let index = 1;

      const onClick = () => {
        loadMore();
        masonry.layout();
      };

      const loadMore = () => {
        const nextIndex = index * 8;

        items.forEach((item, i) => {
          item.inert = !(i < 8 + nextIndex);
        });

        index++;

        if (!items.find((item) => item.inert)) {
          trigger.inert = true;
          trigger.removeEventListener('click', onClick);
        }

        setTimeout(() => {
          // Focus on the first item that is new
          const nextItem = items[nextIndex]?.querySelector('a');

          nextItem?.focus();
        }, 300);
      };

      trigger.addEventListener('click', onClick);
    };

    /**
     * Some items within {@link component} should be visible in a lightbox
     */
    const handleLightbox = () => {
      const items: HTMLElement[] = Array.from(
        component.querySelectorAll('.item-wrapper')
      );

      items.forEach((item, index) => {
        const trigger: HTMLButtonElement = item.querySelector('.item-trigger');
        if (!trigger) return;

        const content: HTMLDivElement = item.querySelector(
          '.blockGalleryLightbox'
        );

        const captionEl =
          item.querySelector<HTMLElement>('.blockGalleryLightbox figcaption') ??
          undefined;

        if (!content) return;

        new Lightbox({
          trigger,
          content,
          labels: {
            lightbox:
              component.getAttribute('data-labels-lightbox') || undefined,
            instanceOf: component.getAttribute('data-labels-of') || undefined,
            instance:
              component.getAttribute('data-labels-instance') || undefined
          },
          counter: {
            caption: captionEl,
            index: index + 1,
            total: items.length
          }
        });
      });
    };

    handleLightbox();
    handleLoadMore();
    handleMasonry();
  });
};
